var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.15264 3.3294C5.2009 1.28115 8.26589 0.498047 12.2166 0.498047H21.4259C25.3767 0.498047 28.4417 1.28115 30.4899 3.3294C32.5382 5.37766 33.3213 8.44265 33.3213 12.3934V21.6027C33.3213 25.5534 32.5382 28.6184 30.4899 30.6667C28.4417 32.7149 25.3767 33.498 21.4259 33.498H12.2166C8.26589 33.498 5.2009 32.7149 3.15264 30.6667C1.10439 28.6184 0.321289 25.5534 0.321289 21.6027V12.3934C0.321289 8.44265 1.10439 5.37766 3.15264 3.3294ZM4.78063 4.95739C3.3754 6.36262 2.62361 8.66973 2.62361 12.3934V21.6027C2.62361 25.3264 3.3754 27.6335 4.78063 29.0387C6.18587 30.4439 8.49297 31.1957 12.2166 31.1957H21.4259C25.1496 31.1957 27.4567 30.4439 28.8619 29.0387C30.2672 27.6335 31.019 25.3264 31.019 21.6027V12.3934C31.019 8.66973 30.2672 6.36262 28.8619 4.95739C27.4567 3.55216 25.1496 2.80037 21.4259 2.80037H12.2166C8.49297 2.80037 6.18587 3.55216 4.78063 4.95739Z",
    fill: "#283B49"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2988 16.9979C10.2988 13.3952 13.2194 10.4746 16.8221 10.4746C20.4248 10.4746 23.3453 13.3952 23.3453 16.9979C23.3453 20.6006 20.4248 23.5211 16.8221 23.5211C13.2194 23.5211 10.2988 20.6006 10.2988 16.9979ZM16.8221 12.7769C14.4909 12.7769 12.6012 14.6667 12.6012 16.9979C12.6012 19.329 14.4909 21.2188 16.8221 21.2188C19.1532 21.2188 21.043 19.329 21.043 16.9979C21.043 14.6667 19.1532 12.7769 16.8221 12.7769Z",
    fill: "#283B49"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9375 9.32395C23.9375 8.47625 24.6247 7.78906 25.4724 7.78906H25.4902C26.3379 7.78906 27.0251 8.47625 27.0251 9.32395C27.0251 10.1716 26.3379 10.8588 25.4902 10.8588H25.4724C24.6247 10.8588 23.9375 10.1716 23.9375 9.32395Z",
    fill: "#283B49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.2d34a57e3ee64f3e2602bff1257a90d7.svg";
export { ForwardRef as ReactComponent };